var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import styled from 'styled-components';
import { Checkbox } from "../../controls";
var GridCheckboxWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    input {\n        display: none;\n    }\n\n    label {\n        display: block;\n        width: 20px;\n        box-sizing: border-box;\n        cursor: pointer;\n        position: relative;\n    }\n"], ["\n    input {\n        display: none;\n    }\n\n    label {\n        display: block;\n        width: 20px;\n        box-sizing: border-box;\n        cursor: pointer;\n        position: relative;\n    }\n"])));
export var gridCheckboxId = 'grid-checkbox-wrapper';
export var gridCheckboxInputId = 'grid-checkbox-input';
export var gridCheckboxLabelId = 'grid-checkbox-label';
var GridCheckbox = /** @class */ (function (_super) {
    __extends(GridCheckbox, _super);
    function GridCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.input = React.createRef();
        _this.inputId = Math.random().toString(16);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    GridCheckbox.prototype.handleClick = function (e) {
        var _a = this.props, onClick = _a.onClick, disabled = _a.disabled;
        e.stopPropagation();
        e.preventDefault();
        if (this.input.current && !disabled) {
            onClick(!this.input.current.checked, e);
        }
    };
    GridCheckbox.prototype.render = function () {
        var _a = this.props, checked = _a.checked, indeterminate = _a.indeterminate, disabled = _a.disabled;
        return (React.createElement(GridCheckboxWrapper, { "data-selector-id": gridCheckboxId },
            React.createElement("input", { "data-selector-id": gridCheckboxInputId, type: "checkbox", id: this.inputId, ref: this.input, checked: checked, disabled: disabled, readOnly: true }),
            React.createElement("label", { htmlFor: this.inputId, "data-selector-id": gridCheckboxLabelId, onClick: this.handleClick },
                React.createElement(Checkbox, { checked: checked, disabled: disabled, indeterminate: indeterminate }))));
    };
    return GridCheckbox;
}(Component));
export default GridCheckbox;
var templateObject_1;
//# sourceMappingURL=GridCheckbox.js.map